import { config } from 'lib/config'

export const ORIGIN_COOKIE =
  config.environment === 'production' ? 'mryum.origin' : 'staging-mryum.origin'
